import Icon from '../components/Icon.vue'

Icon.register({
  landmark: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M501.6 92.1c6.2 2.3 10.4 8.3 10.4 15v36.9c0 8.8-7.2 16-16 16h-480c-8.8 0-16-7.2-16-16v-36.9c0-6.1 4.7-12.8 10.4-15l234.4-90.1c3-1.1 8-2 11.2-2s8.2 0.9 11.2 2zM64 192h64v160h96v-160h64v160h96v-160h64v160h16c8.8 0 16 7.2 16 16v48h-448v-48c0-8.8 7.2-16 16-16h16v-160zM496 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-480c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h480z'
      }
    ]
  }
})
